import React, { useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom';
import LoginPageNew from '../components/LoginPageNew';
import { UserContext } from '../contexts/UserContext';

export default function AuthGuard(props) {
    const Comp = props.Comp;
    let history = useHistory();
    const { username } = useContext(UserContext);

    useEffect(() => {
        if (!username) {
          history.push("/");
        }
      }, [username, history]);
      
    return (
        <>  {!username
            ? <LoginPageNew />
            : <Comp {...props} />
        } </>
    )
}
